import React from 'react';
import theme from 'src/shared/theme';
import styled from 'styled-components';
import { ZTooltip } from '../ztooltip';
import Sparkles from '../svg/sparkles';
import Crown from '../svg/crown';

export const BaseCardTag = styled.span`
    display: inline-flex;
    align-items: center;
    border-radius: 12px;
    font-size: 11px;
    padding: 2px 8px;
    font-weight: 600;
    margin-left: 5px;
    text-decoration: none;
    min-width: fit-content;
    line-height: 1.4;
    white-space: nowrap;
`;

export const NewTag = styled(BaseCardTag)`
    background: ${theme.ai.gradient};
    color: #fff;
`;

export const ComingSoonTag = styled(BaseCardTag)`
    background: #fff4e5;
    color: #b26a00;
`;

export const EarlyAccessTag = styled(BaseCardTag)`
    background: linear-gradient(135deg, rgba(124, 58, 237, 0.15) 0%, rgba(168, 85, 247, 0.15) 50%, rgba(236, 72, 153, 0.15) 100%);
    color: #7c3aed;
`;

export const AiTag = styled(BaseCardTag)`
    background: #ede9fe;
    color: #6d28d9;
`;

const AiSparklesContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
`;

const _aiSparklesTag = ({ className }: { className?: string }) => {
    return (
        <ZTooltip title={'Smart feature powered by AI.'} position={'top'}>
            <AiSparklesContainer className={className}>
                <Sparkles />
            </AiSparklesContainer>
        </ZTooltip>
    );
};

export const AiSparklesTag = styled(_aiSparklesTag)``;

const CrownUpgradeContainer = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 16px;
    margin-left: 0;

    svg {
        fill: #f0047f !important;
    }
`;

const _crownBadgeTag = ({ className, tooltip }: { className?: string; tooltip?: React.ReactNode }) => {
    const content = (
        <CrownUpgradeContainer className={className}>
            <Crown />
        </CrownUpgradeContainer>
    );

    return tooltip ? (
        <ZTooltip html={tooltip} position='top'>
            {content}
        </ZTooltip>
    ) : (
        content
    );
};

export const CrownBadgeTag = styled(_crownBadgeTag)``;
